import { render, staticRenderFns } from "./BCXMessengerChatGroupMember.vue?vue&type=template&id=682e6cfa&scoped=true"
import script from "./BCXMessengerChatGroupMember.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCXMessengerChatGroupMember.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BCXMessengerChatGroupMember.vue?vue&type=style&index=0&id=682e6cfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682e6cfa",
  null
  
)

export default component.exports